import { FiltersQuery } from '@generated'

export function getAttributeIds(filtersQuery: FiltersQuery, chosenAttributeId: number) {
  return filtersQuery?.filters.articleAttributeFilters.reduce(
    (acc, { articleFilterAttributeValues, attributeID }) => {
      if (attributeID === chosenAttributeId) {
        return [
          ...acc,
          ...articleFilterAttributeValues.map(({ attributeValueID }) => attributeValueID),
        ]
      }
      return acc
    },
    [],
  )
}
